import i18n from "@/i18n";

export const zoneFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "width",
        label: i18n.t("common.width"),
        tdClass: "td-sm"
    },
    {
        key: "height",
        label: i18n.t("common.height"),
        tdClass: "td-sm"
    },
    {
        key: "x",
        label: i18n.t("background.posX"),
        tdClass: "td-sm"

    },
    {
        key: "y",
        label: i18n.t("background.posY"),
        tdClass: "td-sm"

    },
    {
        key: "actions",
        label: ""
    }];
